import gql from 'graphql-tag';

const MODIFY_PLANOGRAM_ITEM_CAPACITY = gql`
	mutation modifyPlanogramItem (
		$id: ID,
		$values: PlanogramItemInput,
	) {
		modifyPlanogramItem(
			id: $id,
			values: $values,
		) {
			id
			capacity
			queuedCapacity
			queuedCapacityType
		}
	}
`;

export default MODIFY_PLANOGRAM_ITEM_CAPACITY;

